"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Radio = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const Radio = ({ value, onChange, group, checked, error, id, disabled, className }) => {
    return (react_1.default.createElement("input", { type: "radio", value: value, name: group, checked: checked, id: id, disabled: disabled, onChange: onChange && ((e) => onChange(value, e)), className: (0, classnames_1.default)('relative h-8 w-8 cursor-pointer appearance-none rounded-full border-2 border-grey-3 before:absolute before:left-1/2 before:top-1/2 before:h-4/5 before:w-4/5 before:-translate-x-1/2 before:-translate-y-1/2 before:rounded-full before:bg-transparent checked:border-blue-5 checked:before:bg-blue-5 focus:ring focus:ring-blue-4/40 disabled:opacity-40', {
            'border-red-5 checked:border-red-5': error,
        }, className) }));
};
exports.Radio = Radio;
